import { create } from 'zustand';

import { registerWorkspaceReset } from '@/lib/workspace/workspaceResetRegistry';

export interface VideoJobState {
  jobId: string;
  status: 'pending' | 'submitted' | 'processing' | 'uploading' | 'completed' | 'failed' | 'timeout';
  videoUrl?: string;
  thumbnailUrl?: string;
  errorMessage?: string;
  createdAt?: string;
  completedAt?: string;
}

interface VideoJobsDataStore {
  jobs: Record<string, VideoJobState>;
  setJob: (jobId: string, state: VideoJobState) => void;
  reset: () => void;
}

export const useVideoJobsDataStore = create<VideoJobsDataStore>((set) => ({
  jobs: {},
  setJob: (jobId, state) =>
    set((prev) => ({
      jobs: {
        ...prev.jobs,
        [jobId]: state,
      },
    })),
  reset: () => set({ jobs: {} }),
}));

// This map lives outside the React Query cache (jobs are keyed by jobId, not
// by workspace) and useGlobalJobMonitor only ever ADDS entries to it — a
// workspace switch that populates the new workspace's jobs never removes the
// previous workspace's, so without this registration a job-progress lookup
// by id could still resolve to a job that belongs to a workspace the user
// switched away from. Same reasoning as useArtifactStore's registration; see
// src/lib/workspace/workspaceResetRegistry.ts.
registerWorkspaceReset('video-jobs-data-store', () => {
  useVideoJobsDataStore.getState().reset();
});
